import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { c as l } from "../../clsx-OuTLNxxd.js";
import { formatPrice as n } from "../utils.js";
const p = "PriceBox-module_price-box__ZJgbg",
  b = "PriceBox-module_price-value__ZvIGK",
  _ = "PriceBox-module_discounted__leeK8",
  u = "PriceBox-module_secondary__9b9fr",
  x = "PriceBox-module_label-uppercase__KeC0A",
  B = "PriceBox-module_top-label__btPVl",
  P = "PriceBox-module_bottom-label__z0ake",
  y = "PriceBox-module_bottom-disclaimer__Y10qW",
  e = {
    priceBox: p,
    priceValue: b,
    discounted: _,
    secondary: u,
    labelUppercase: x,
    topLabel: B,
    bottomLabel: P,
    bottomDisclaimer: y
  },
  N = _ref => {
    let {
      price: o,
      chipBackgroundColor: c = "white",
      topLabel: r,
      bottomLabel: s,
      rightLabel: a,
      className: m,
      priceType: d = "primary"
    } = _ref;
    return /* @__PURE__ */i("div", {
      className: l(e.priceBox, m),
      children: [r, /* @__PURE__ */t(L, {
        price: o,
        chipBackgroundColor: c,
        priceType: d,
        children: a
      }), /* @__PURE__ */t("div", {
        className: e.bottomDisclaimer,
        children: s
      })]
    });
  },
  L = _ref2 => {
    let {
      price: o,
      chipBackgroundColor: c,
      children: r,
      className: s,
      priceType: a
    } = _ref2;
    return /* @__PURE__ */i("div", {
      className: l(e.priceValue, {
        [e.discounted]: o.type == "discounted",
        [e.secondary]: a == "secondary"
      }, s),
      children: [n(o, c), r]
    });
  },
  V = _ref3 => {
    let {
      className: o,
      uppercase: c,
      children: r
    } = _ref3;
    return /* @__PURE__ */t("div", {
      className: l(e.topLabel, {
        [e.labelUppercase]: c
      }, o),
      children: r
    });
  },
  U = _ref4 => {
    let {
      className: o,
      uppercase: c,
      children: r
    } = _ref4;
    return /* @__PURE__ */t("div", {
      className: l(e.bottomLabel, {
        [e.labelUppercase]: c
      }, o),
      children: r
    });
  };
export { N as PriceBox, U as PriceBoxBottomLabel, V as PriceBoxTopLabel, L as PriceValue };